import { useId } from 'react';

/** The Option 1 sign-in backdrop: soft blue waves and a fading corner grid. */
export function AuthBackdrop() {
  const id = useId();
  return (
    <svg className="brand-auth-backdrop" viewBox="0 0 1440 650" preserveAspectRatio="none" aria-hidden="true">
      <defs>
        <linearGradient id={`${id}-wave`} x1="0" y1="0" x2="1" y2="0">
          <stop stopColor="var(--auth-wave-left)" />
          <stop offset=".48" stopColor="var(--auth-wave-center)" />
          <stop offset="1" stopColor="var(--auth-wave-right)" />
        </linearGradient>
        <radialGradient id={`${id}-glow`}>
          <stop stopColor="var(--auth-glow)" stopOpacity=".75" />
          <stop offset="1" stopColor="var(--auth-glow)" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={`${id}-fade`} x2="0" y2="1">
          <stop stopColor="white" />
          <stop offset=".7" stopColor="black" />
        </linearGradient>
        <linearGradient id={`${id}-corners`}>
          <stop stopColor="white" />
          <stop offset=".3" stopColor="black" />
          <stop offset=".7" stopColor="black" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <pattern id={`${id}-grid`} width="16" height="16" patternUnits="userSpaceOnUse">
          <path d="M16 0H0V16" fill="none" stroke="var(--auth-grid)" strokeWidth=".8" />
          <circle cx=".5" cy=".5" r="1.1" fill="var(--auth-grid)" />
        </pattern>
        <mask id={`${id}-vertical-fade`}>
          <rect width="1440" height="650" fill={`url(#${id}-fade)`} />
        </mask>
        <mask id={`${id}-corner-fade`}>
          <rect width="1440" height="650" fill={`url(#${id}-corners)`} />
        </mask>
      </defs>
      <ellipse cx="30" cy="-30" rx="650" ry="450" fill={`url(#${id}-glow)`} />
      <ellipse cx="1420" cy="80" rx="600" ry="450" fill={`url(#${id}-glow)`} />
      <path d="M-80-80H1520V330C1270 100 1080 80 815 140S300 220 100-80Z" fill={`url(#${id}-wave)`} />
      <path d="M680-40C960 10 1220 90 1520 310" fill="none" stroke="var(--auth-wave-edge)" strokeWidth="1.5" />
      <g mask={`url(#${id}-vertical-fade)`}>
        <rect width="1440" height="650" fill={`url(#${id}-grid)`} mask={`url(#${id}-corner-fade)`} />
      </g>
    </svg>
  );
}
